module.exports = __webpack_public_path__ + "static/banner3-80f603b50ee4e09b83d65de1e13c7c26.jpg";